module.exports = __webpack_public_path__ + "static/media/right-arrow.36a1d5da.svg";